import { render, staticRenderFns } from "./logMaintenanceAdd.vue?vue&type=template&id=5b8b9120&scoped=true&"
import script from "./logMaintenanceAdd.vue?vue&type=script&lang=js&"
export * from "./logMaintenanceAdd.vue?vue&type=script&lang=js&"
import style0 from "./logMaintenanceAdd.vue?vue&type=style&index=0&id=5b8b9120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b9120",
  null
  
)

export default component.exports